var exports = {
  "az": "Box__PiJOSr",
  "wy": "Box_1__z9HX3E",
  "pv": "Box_2__M8iAnv",
  "w9": "Box_3__wopAlk",
  "pQ": "Box_4__vTeWQ8",
  "ws": "Box_5__LftDhI",
  "vb": "VerifiedHTMLBox__4GHziY",
  "D6": "Box_6__-Lxi4G",
  "KI": "Box_7__kV9Pcm",
  "pm": "Box_8__jyQNxv",
  "w0": "Box_9__WG9gtB",
  "m4": "Octicon__iBTJWD",
  "Tq": "permissionIcon__Jo2HzJ",
  "SS": "limitationIcon__MLopOZ",
  "r": "conditionIcon__PgcL5h",
  "Oh": "Box_10__fgddB5",
};

module.exports = exports;
